import { booleanToText } from 'utils/format';
import BeforeAndAfterWithArrow from './BeforeAndAfterWithArrow';
import { Spacer } from '@ontruck/orc';

import FormattedDate from './FormattedDate';
import LoadChange from './LoadChange';
import { t_stop, stopHasChanges, someHasChanges, fieldHasChanges } from './constants';

const TimesRender = ({ timeFrom, timeTo, tzFrom, tzTo, label }) => {
  if (![timeFrom, timeTo, tzFrom, tzTo].every((isTrue) => !!isTrue)) {
    return null;
  }

  const timeFromBefore = timeFrom?.before;
  const timeFromAfter = timeFrom?.after;

  const timeToBefore = timeTo?.before;
  const timeToAfter = timeTo?.after;

  const tzFromBefore = tzFrom?.before;
  const tzFromAfter = tzFrom?.after;

  const tzToBefore = tzTo?.before;
  const tzToAfter = tzTo?.after;

  const beforeComponent = (
    <FormattedDate
      timeFrom={timeFromBefore}
      tzFrom={tzFromBefore}
      timeTo={timeToBefore}
      tzTo={tzToBefore}
    />
  );

  return (
    <div>
      {label}: {beforeComponent}
      {!!timeFromBefore && <> &#8594; </>}
      <FormattedDate
        timeFrom={timeFromAfter}
        tzFrom={tzFromAfter}
        timeTo={timeToAfter}
        tzTo={tzToAfter}
      />
    </div>
  );
};

const forceRenderingIfNoBefore = () => false;

const StopChange = ({ stop }) => {
  if (!Object.keys(stop || {}).length) {
    return null;
  }

  if (!stopHasChanges(stop)) {
    return null;
  }

  return (
    <Spacer mBottom="XS" data-testid="stop_change">
      <div>
        <strong>
          {t_stop.types[stop?.stop_type?.after] || stop?.stop_type?.after} &mdash;{' '}
          {stop?.company_name?.after}
        </strong>
      </div>
      {Array.isArray(stop?.loads) &&
        stop?.loads?.map((load, key) => <LoadChange load={load} key={key} />)}
      {fieldHasChanges(stop?.company_name) && (
        <BeforeAndAfterWithArrow
          label={t_stop.company}
          before={stop?.company_name?.before}
          after={stop?.company_name?.after}
          shouldNotRender={forceRenderingIfNoBefore}
        />
      )}
      {someHasChanges([stop?.zipcode, stop?.label]) && (
        <BeforeAndAfterWithArrow
          label={t_stop.city}
          before={
            stop?.zipcode?.before && stop?.label?.before
              ? `${stop?.zipcode?.before} - ${stop?.label?.before}`
              : ''
          }
          after={`${stop?.zipcode?.after} - ${stop?.label?.after}`}
        />
      )}
      {someHasChanges([stop?.time_from, stop?.time_to, stop?.time_from_tz, stop?.time_to_tz]) && (
        <TimesRender
          timeFrom={stop?.time_from}
          timeTo={stop?.time_to}
          tzFrom={stop?.time_from_tz}
          tzTo={stop?.time_to_tz}
          label={t_stop.times}
        />
      )}
      {fieldHasChanges(stop?.internal_reference) && (
        <BeforeAndAfterWithArrow
          label={t_stop.reference}
          before={stop?.internal_reference?.before}
          after={stop?.internal_reference?.after}
        />
      )}
      {fieldHasChanges(stop?.instructions) && stop?.instructions?.before !== null && (
        <div>{t_stop.instructions_edited}</div>
      )}
      {fieldHasChanges(stop?.extra_handling) && (
        <BeforeAndAfterWithArrow
          label={t_stop.handling}
          before={stop?.extra_handling?.before}
          after={stop?.extra_handling?.after}
          valueFormatter={(value) => booleanToText(value)}
          shouldNotRender={(before, after) => {
            if (before === null && !after) {
              return true;
            }
            return false;
          }}
        />
      )}
    </Spacer>
  );
};

export default StopChange;
